import {useFeatureAppEnv} from '@smart/feature-app/react';
import type {PriceTypeV1} from '@smart/price-preferences-provider';
import type {MarketId} from '@smart/types';
import {PAYMENT_TYPE} from '@smart/types';
import {getLabelsForMarketPriceTypePaymentType} from '@smart/utils';
import {Text} from '@smart/web-components';
import {clsx} from 'clsx';
import React from 'react';
import {useAppModel} from '../../contexts';
import {useLocale} from '../../hooks/use-locale';
import styles from './tax-label.module.scss';
import type {PriceKey} from '.';
interface TaxLabelProps {
  deprecatedVatLabel: string | undefined;
  priceKey: PriceKey;
  priceType: PriceTypeV1;
  version: 'v1' | 'v2';
}
export const TaxLabel = ({
  deprecatedVatLabel,
  priceKey,
  priceType,
  version,
}: TaxLabelProps) => {
  const {'endpoint-directory': endpointDirectory} =
    useFeatureAppEnv().featureServices;

  const {appModel} = useAppModel();
  const {marketId, language} = useLocale();

  let newTaxLabel;
  if (appModel?.excludesTax && appModel?.includesTax) {
    const {vatLabel} = getLabelsForMarketPriceTypePaymentType({
      marketId: marketId as MarketId,
      labels: {
        excludeVatLabel: appModel?.excludesTax,
        includesVatLabel: appModel?.includesTax,
      },
      priceType,
      paymentType:
        priceKey === `totalPrice` ? PAYMENT_TYPE.CASH : PAYMENT_TYPE.LEASING,
    });

    if (vatLabel && typeof vatLabel === `string`) {
      newTaxLabel = vatLabel;
    }
  }

  if (endpointDirectory.envName !== `prod`) {
    console.debug({
      'AEM Tax Label Path': newTaxLabel
        ? `/content/common/${marketId}/${language}/common-attributes`
        : `/content/stock-search/${marketId}/${language}/stock-search-content`,
    });
  }

  return (
    <Text
      tag="span"
      className={clsx(
        styles[`tax-label__color`],
        version === `v2` && styles[`tax-label`],
      )}
      variant={version === `v1` ? `paragraph-200` : `legal-100`}
    >
      {newTaxLabel ?? deprecatedVatLabel}
    </Text>
  );
};
